import { AnimatedSprite } from 'pixi.js';
import { getFrames } from '@/assets/resolver';

const PORTAL_RADIUS = 60;

/**
 * Level transition gate. Activates when the boss dies (always active in sandbox);
 * entering it takes the player to the intermission screen (docs/01 — portal transition).
 */
export class Portal {
  readonly sprite: AnimatedSprite;
  x = 0;
  y = 0;
  active = true;

  constructor() {
    this.sprite = new AnimatedSprite(getFrames('env/portal-gate'));
    this.sprite.anchor.set(0.5);
    this.sprite.animationSpeed = 0.12;
    this.sprite.play();
  }

  place(x: number, y: number): void {
    this.x = x;
    this.y = y;
    this.sprite.position.set(x, y);
  }

  setActive(active: boolean): void {
    this.active = active;
    this.sprite.visible = active;
  }

  overlaps(px: number, py: number): boolean {
    return this.active && Math.hypot(px - this.x, py - this.y) < PORTAL_RADIUS * 0.7;
  }

  render(): void {
    // Subtle breathing effect
    const s = 1 + Math.sin(performance.now() / 400) * 0.04;
    this.sprite.scale.set(s);
  }
}
